import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const payloadSchema = z.object({
    reason: z.string().nullable().optional(),
});

export const runCancelRequestedDefinitions = {
    run_cancel_requested: defineInvisible('run_cancel_requested', {
        disposition: 'invisible',
        schema: payloadSchema,
        malformed: { kind: 'skip' },
        evidence(_payload, occurrence) {
            const source = occurrence.committed ?? occurrence.pending;
            if (source === null) {
                return null;
            }
            return {
                kind: 'interrupt_requested',
                occurredAtMs: Date.parse(source.created_at),
            };
        },
    }),
} as const;

export const runCancelRequestedContractFixtures = {
    valid: {
        type: 'run_cancel_requested',
        reason: 'cancel-request-reason-sentinel',
    },
    malformed: {
        type: 'run_cancel_requested',
        reason: ['cancel-request-reason-sentinel'],
    },
} as const;
